import React from 'react'
import { useLocation } from 'react-router-dom'

const query = ['/club/', '/membership/', '/welcome', '/age-limit']

function toggleBodyClass(condition) {
  document.body.classList[condition ? 'add' : 'remove']('no-sideMenu')
}

export const useShowSideMenuBasedOnRouteChanges = () => {
  const location = useLocation()
  const previousRoute = React.useRef('')
  const [showSideMenu, setShowSideMenu] = React.useState(true)

  React.useEffect(() => {
    const currentRoute = location.pathname

    if ([currentRoute, `${previousRoute.current}`].some(str => query.find(url => str.includes(url)))) {
      const isOnQuery = query.find(url => currentRoute.includes(url))

      setShowSideMenu(!isOnQuery)
      toggleBodyClass(isOnQuery)
    }

    previousRoute.current = location.pathname
  }, [location])

  return showSideMenu
}
